import raveIf from '@magalu/rave/template/rave-if';
import raveExp from '@magalu/rave/template/rave-exp';
import encodedObjectParser from '@magalu/rave/parser/encoded-object-parser';
import numberParser from '@magalu/rave/parser/number-parser';
import uppercaseParser from '@magalu/rave/parser/uppercase-parser';

export const getComponents = props => ({
    'header-preconnect-0': {
      name: `Preconnect`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        list: [
          `https://a-static.mlcdn.com.br`,
          `https://www.googletagmanager.com`,
          `https://wx.mlcdn.com.br`,
          `https://6590300.fls.doubleclick.net`,
          `https://ad.doubleclick.net`,
          `https://adservice.google.com`,
          `https://analytics.google.com`,
          `https://analytics.pangle-ads.com`,
          `https://analytics.tiktok.com`,
          `https://analytics.twitter.com`,
          `https://bat.bing.com`,
          `https://c.bing.com`,
          `https://c.clarity.ms`,
          `https://cas.avalon.perfdrive.com`,
          `https://cdn.perfdrive.com`,
          `https://connect.facebook.net`,
          `https://d.clarity.ms`,
          `https://googleads.g.doubleclick.net`,
          `https://gum.criteo.com`,
          `https://i.btg360.com.br`,
          `https://s.pinimg.com`,
          `https://sc-static.net`,
          `https://script.hotjar.com`,
          `https://site-content.magazineluiza.com.br`,
          `https://static.ads-twitter.com`,
          `https://static.criteo.net`,
          `https://static.hotjar.com`,
          `https://t.co`,
          `https://tags.creativecdn.com`,
          `https://td.doubleclick.net`,
          `https://tr.snapchat.com`,
          `https://tr6.snapchat.com`,
          `https://us.creativecdn.com`,
          `https://www.clarity.ms`,
          `https://www.facebook.com`,
          `https://www.google-analytics.com`,
          `https://www.google.com`,
          `https://www.google.com.br`,
          `https://dev.visualwebsiteoptimizer.com`,
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-preconnect-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-datadog-1': {
      name: `Datadog`,
      from: `@magalu/ecomm-components/rave/scripts/Datadog`,
      props: {
        applicationId: `42d9dfdf-d830-46c4-8e5d-055511be14b7`,
        clientToken: `pub69c5389a277d736249ea5c3018a49ce7`,
        service: `mixer-web`,
        version: `v${props?.data?.version}`,
        sessionSampleRate: 3,
        sessionReplaySampleRate: 1,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-datadog-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-google-tag-manager-2': {
      name: `GoogleTagManager`,
      from: `@magalu/ecomm-components/rave/scripts/GoogleTagManager`,
      props: {
        id: `GTM-N9NRZNKX`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-google-tag-manager-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-script-3': {
      name: `Script`,
      namedImport: true,
      from: `@magalu/rave/components`,
      props: {
        src: `https://wx.mlcdn.com.br/shared/azion/azfp-63fe5.min.js`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-script-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-all-in-4': {
      name: `AllIn`,
      from: `@magalu/ecomm-components/rave/scripts/AllIn`,
      props: {
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-all-in-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-criteo-5': {
      name: `Criteo`,
      from: `@magalu/ecomm-components/rave/scripts/Criteo`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-criteo-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-bing-6': {
      name: `Bing`,
      from: `@magalu/ecomm-components/rave/scripts/Bing`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-bing-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-tik-tok-7': {
      name: `TikTok`,
      from: `@magalu/ecomm-components/rave/scripts/TikTok`,
      props: {
        id: `C1I87V1T0U322RQPSRKG`,
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-tik-tok-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-rtbhouse-8': {
      name: `RTBHouse`,
      from: `@magalu/ecomm-components/rave/scripts/RTBHouse`,
      props: {
        id: `msWukR4UlwKQouZSY8IT`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-rtbhouse-8`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-stewie-9': {
      name: `Stewie`,
      from: `@magalu/ecomm-components/rave/scripts/Stewie`,
      props: {
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-stewie-9`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-spotify-ad-analytics-10': {
      name: `SpotifyAdAnalytics`,
      from: `@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics`,
      props: {
        id: `66f417c2d2344c0980e19d4e7f996073`,
        strategy: `worker`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-spotify-ad-analytics-10`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-hotjar-11': {
      name: `Hotjar`,
      from: `@magalu/ecomm-components/rave/scripts/Hotjar`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      props: {
        id: `4936838`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-hotjar-11`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-vwo-12': {
      name: `Vwo`,
      from: `@magalu/ecomm-components/rave/scripts/Vwo`,
      id: `header-vwo-12`,
      props: {
        id: `752930`,
        strategy: `lazyOnload`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-13': {
      name: `Loader`,
      from: `@magalu/ecomm-components/rave/Loader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-13`,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-14': {
      name: `StateLoader`,
      from: `@magalu/ecomm-components/rave/StateLoader`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-14`,
      spacing: {
      },
      ssr: false,
    },
    'header-ads-banner-15': {
      name: `AdsBanner`,
      csr: {
        props: {
        },
        strategy: `onLazyLoading`,
      },
      from: `@magalu/ecomm-components/rave/AdsBanner`,
      props: {
        className: `rounded-none h-[64px]`,
        containerClassName: `bg-brand-default`,
        slot: `mobile_hypertop`,
        position: 1,
        page: props?.route?.name,
        size: `small`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `header-ads-banner-15`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-header-16': {
      name: `Header`,
      from: `@magalu/ecomm-components/rave/Header`,
      props: {
        signOutUrl: `https://sacolamobile.magazineluiza.com.br/#/sair/?next=https%3A%2F%2Fm.magazineluiza.com.br%2F&origin=magazineluiza`,
        footerLabels: [
          `Compre pelo televendas`,
          `Seg. à Dom. (exceto feriados)`,
          `das 8h às 20h`,
        ],
        logoUrl: `/`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-header-16`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-event-page-view-dispatcher-17': {
      name: `EventPageViewDispatcher`,
      from: `@magalu/ecomm-components/rave/EventPageViewDispatcher`,
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `header-event-page-view-dispatcher-17`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'header-loader-13-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-loader-13-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'header-state-loader-14-children-page-loading-0': {
      name: `PageLoading`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      from: `@magalu/ecomm-components/components/PageLoading`,
      displayCondition: null,
      hasSpacing: false,
      id: `header-state-loader-14-children-page-loading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'content-row-0': {
      name: `Row`,
      from: `@magalu/ecomm-components/components/Row`,
      props: {
        className: `flex-col px-md items-center bg-surface-container-lowest`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0`,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-0': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        as: `h1`,
        title: `Oops!`,
        className: `font-2xlg-bold mt-sm mx-xsm text-on-interaction-default-inverted`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-1': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Achei que essa página também estava por aqui`,
        as: `p`,
        className: `font-2xsm-regular m-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-2': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: raveIf([
          props?.route?.isReady,
          props?.route?.asPath,
          ``,
        ]),
        as: `p`,
        className: `font-2xsm-bold m-xsm w-[100%] truncate`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-2`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-image-3': {
      name: `Image`,
      from: `@magalu/ecomm-components/components/Image`,
      props: {
        src: `https://wx.mlcdn.com.br/site/shared/error/temnomagalu.gif`,
        width: `186`,
        height: `186`,
        alt: `produtos magalu`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-image-3`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-4': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `Mas, espera 🤔`,
        as: `p`,
        className: `font-2xsm-regular m-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-4`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-5': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `#TemNoMagalu`,
        as: `p`,
        className: `font-2xsm-bold mb-xsm`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-5`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-heading-6': {
      name: `Heading`,
      from: `@magalu/ecomm-components/rave/Heading`,
      props: {
        title: `É só fazer uma nova busca, ou então voltar para a página inicial`,
        as: `p`,
        className: `font-2xsm-regular m-xsm w-[230px] text-center`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-heading-6`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'content-row-0-children-button-7': {
      name: `Button`,
      from: `@magalu/ecomm-components/rave/Button`,
      props: {
        pushToSiteDomain: true,
        href: `/`,
        label: `VOLTAR PARA O INÍCIO`,
        as: `a`,
        className: `font-2xsm-regular mb-lg mt-sm`,
        size: `large`,
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `content-row-0-children-button-7`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
    'footer-back-to-top-0': {
      name: `BackToTop`,
      from: `@magalu/ecomm-components/components/BackToTop`,
      csr: {
        props: {
        },
        strategy: `onActivityDetection`,
      },
      displayCondition: null,
      hasSpacing: false,
      id: `footer-back-to-top-0`,
      placeholder: undefined,
      spacing: {
      },
      ssr: false,
    },
    'footer-footer-1': {
      name: `Footer`,
      from: `@magalu/ecomm-components/components/Footer`,
      props: {
        as: `div`,
        data: [
          `Preços e condições de pagamento exclusivos para compras via internet, podendo variar nas lojas físicas. Ofertas válidas na compra de até 5 peças de cada produto por cliente, até o término dos nossos estoques para internet. Caso os produtos apresentem divergências de valores, o preço válido é o da sacola de compras. Vendas sujeitas a análise e confirmação de dados.`,
          {
            text: `Política de privacidade`,
            href: `https://especiais.magazineluiza.com.br/politica-de-privacidade/`,
            rel: `noopener`,
          },
          [
            `Magazine Luiza S/A - CNPJ: 47.960.950/1088-36`,
            `Rua Arnulfo de Lima, 2385 - Vila Santa Cruz`,
            `CEP: 14.403-471 - Franca/SP`,
            `Endereço eletrônico: www.magazineluiza.com.br`,
            `www.magazineluiza.com.br/formulariocontato`,
            `® Magazine Luiza – Todos os direitos reservados`,
          ],
        ],
      },
      csr: false,
      displayCondition: null,
      hasSpacing: false,
      id: `footer-footer-1`,
      placeholder: undefined,
      spacing: {
      },
      ssr: true,
    },
  });

export const dataSource = {
  "graphql": {
    "configsDir": "config",
    "serverDefaultOptions": {
      "query": {
        "errorPolicy": "all",
        "fetchPolicy": "no-cache"
      }
    }
  }
}

export const getHeadProps = (props) => ({
    links: [
      {
        rel: `shortcut icon`,
        href: `https://site-content.magazineluiza.com.br/static/img/default/favicon-cc4cf323.png`,
      },
      {
        rel: `shortcut icon`,
        type: `image/ico`,
        href: `https://site-content.magazineluiza.com.br/static/img/default/favicon-cc4cf323.png`,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://m.magazineluiza.com.br/tom/fonts/magalu-ui-variable/files/MagaluUIVariable.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff2`,
        fetchpriority: `high`,
        href: `https://m.magazineluiza.com.br/tom/icons/${props?.data?.iconsVersion}/font/tom-icons.woff2`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/woff`,
        fetchpriority: `high`,
        href: `https://m.magazineluiza.com.br/tom/icons/${props?.data?.iconsVersion}/font/tom-icons.woff`,
        crossOrigin: ``,
      },
      {
        preload: true,
        as: `font`,
        type: `font/truetype`,
        fetchpriority: `high`,
        href: `https://m.magazineluiza.com.br/tom/icons/${props?.data?.iconsVersion}/font/tom-icons.ttf`,
        crossOrigin: ``,
      },
    ],
  });

export const componentsList = [
  "Preconnect",
  "Datadog",
  "GoogleTagManager",
  "Script",
  "AllIn",
  "Criteo",
  "Bing",
  "TikTok",
  "RTBHouse",
  "Stewie",
  "SpotifyAdAnalytics",
  "Hotjar",
  "Vwo",
  "Loader",
  "StateLoader",
  "AdsBanner",
  "Header",
  "EventPageViewDispatcher",
  "PageLoading",
  "Row",
  "Heading",
  "Image",
  "Button",
  "BackToTop",
  "Footer"
];

export const routeInfo = {
  id: '404',
  name: 'internal-not-found-page',
  pathPattern: '/error-404/',
  pathAliases: {},
  parser: {
    query: {
      "page": numberParser(),
      "categoryId": uppercaseParser(),
      "subCategoryId": uppercaseParser(),
    },
    cookie: {
      "ml2_sid_c": encodedObjectParser(),
    },
  },
  renderMethod: 'SSG',
  forwardCookies: 'toggle_coupon',
  forwardHeaders: 'theme'
};

export const manifest = {
  "useTypescript": true
};

export const getGlobalClassName = props => ([
    raveExp({
      '??': [
        props?.route?.headers?.theme,
        ``,
      ],
    }),
  ]).join(' ').trim();

export const getPageVariables = props => ({
  });

export const middlewaresArgs = ({ 
      "getUserInfo": (props) => ({
  }),
      "getVersions": (props) => ({
  }),
 });

export const config = {
  assetPrefix: 'https://wx.mlcdn.com.br/mixer-web/static/v1.91.5',
};
